import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IInduccionReprogramarModel } from 'src/app/models/interfaces/induccion/IInduccionModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';

@Component({
  selector: 'app-induccion-reprogramar-dialog',
  templateUrl: './induccion-reprogramar-dialog.component.html',
  styleUrls: ['./induccion-reprogramar-dialog.component.css']
})
export class InduccionReprogramarDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<InduccionReprogramarDialogComponent>,
    private induccionService: InduccionService,
    @Inject(MAT_DIALOG_DATA) public model: IInduccionReprogramarModel
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }  

  onSubmit(form: NgForm) {
    // console.log(this.data.persona.documentos);
    if (!form.invalid) {      
      this.induccionService.reprogramar(this.model).subscribe(p => {
        // console.log(p);
        this.dialogRef.close();
      });  
    }
  }
}
